export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      coaches: "Coaches",
      athletes: "Athletes",
      about: "About Us",
      joinUs: "Join Us"
    },
    
    // Home Page
    home: {
      heroTitle: "PODIUM RACING MIDDLE EAST",
      heroSubtitle: "Join Our Tribe",
      joinOurTribe: "Join Our Tribe",
      meetOurCoaches: "Meet Our Coaches",
      movingBar: [
        "Push Your Limits – Own Every Mile",
        "Train Hard – Shine Strong",
        "One Step Today – A Giant Leap Tomorrow",
        "From Sweat to Success – We've Got You",
        "Dream Big – Race Bigger",
        "Stronger Every Session – Closer Every Goal",
        "Rise. Ride. Run. Repeat.",
        "Turn Effort into Endurance",
        "Your Journey – Our Mission",
        "Built for Athletes – Driven by Passion"
      ],
      vision: "VISION",
      visionContent1: "At Podium Racing Middle East, our vision is to cultivate a team of high-performance athletes on the level of junior, amateur, elite and professional throughout the region. By integrating world class training methodologies from Podium Racing US, we strive to elevate the competitive standard in the Middle East, preparing athletes to excel on the international stage.",
      visionContent2: "Our commitment extends beyond performance we aim to foster a culture of excellence, sportsmanship, and knowledge sharing, ensuring that every athlete not only reaches their peak potential but also contributes to the growth and ethics of sports in the region.",
      visionContent3: "Raising the bar. Shaping champions. Inspiring the future!",
      mission: "Mission",
      missionContent1: "At Podium Racing Middle East, our mission is to bridge the gap between athletes and top-tier coaches across the Middle East. Whether you're seeking guidance in multi-sport disciplines or specialized training in swimming, cycling, or running, we connect you with the most qualified coaches to elevate your performance.",
      missionContent2: "By partnering with expert coaches who follow the highest standards in sports science and training methodologies, we ensure that every athlete receives the tailored support they need to reach peak performance.",
      missionContent3: "Our goal is simple: to empower you to become a high-performance athlete!",
      whatWeOffer: "What We Offer",
      swim: "Swim",
      swimDesc: "Master the art of swimming with expert coaching",
      bike: "Bike",
      bikeDesc: "Develop cycling skills and endurance",
      run: "Run",
      runDesc: "Improve running technique and performance",
      triathlon: "Triathlon",
      triathlonDesc: "Complete triathlon training and racing",
      quote: "Triathlon teaches us to challenge ourselves. It teaches us to push beyond where we thought we could go. It helps us to find out what we are made of. This is what we do. This is what it's all about.",
      quoteAuthor: "Podium Racing Middle East",
      joinOurTribeTitle: "Join Our Tribe",
      joinContent: "Ready to start your triathlon journey? Join Podium Racing Middle East and become part of a community dedicated to excellence, performance, and continuous improvement.",
      applyToJoin: "Apply to Join PRME"
    },
    
    // Coaches Page
    coaches: {
      heroTitle: "Our Coaches",
      heroSubtitle: "Meet our world-class coaching team dedicated to your triathlon success",
      coachingPrograms: "Coaching Programs",
      beginnerProgram: "Beginner Program",
      beginnerDescription: "Perfect for those new to racing. Learn fundamentals, safety protocols, and basic racing techniques.",
      intermediateProgram: "Intermediate Program", 
      intermediateDescription: "For experienced racers looking to improve skills and performance on the track.",
      eliteProgram: "Elite Program",
      eliteDescription: "Intensive training for competitive racers aiming for professional racing careers.",
      safetyFundamentals: "Safety fundamentals",
      basicRacingTechniques: "Basic racing techniques",
      equipmentFamiliarization: "Equipment familiarization",
      tipsForBetterTechnique: "Tips for a better technique",
      advancedTechniques: "Advanced techniques",
      performanceOptimization: "Performance optimization",
      strategyDevelopment: "Strategy development",
      competitionPreparation: "Competition preparation",
      professionalTechniques: "Professional techniques",
      mentalConditioning: "Mental conditioning",
      advancedStrategy: "Advanced strategy",
      careerDevelopment: "Career development",
      asACoach: "As a Coach:",
      asAnAthlete: "As an Athlete:",
      achievements: "Achievements:",
      expertise: "Expertise:",
      coachingExperience: "Coaching Experience:",
      experience: "Experience:",
      certifications: "Certifications:",
      myPhilosophy: "My Philosophy:",
      
      // Coach Data Translations
      coaches: {
        seifeldeen: {
          name: "Seifeldeen Ismail",
          title: "Triathlon Coach & Professional Athlete",
          description: "I help triathletes of all levels reach their goals faster, stay injury-free, and enjoy the process. My coaching is built on smart training, not just hard work. My approach blends science, experience, and personalized planning—because progress should be sustainable, not exhausting.",
          asCoach: [
            "Coached athletes to qualify for Ironman 70.3 World Championships.",
            "Guided a leukemia survivor to complete 4×70.3 races and a full Ironman within two years—with new personal bests in all disciplines",
            "Work with all levels, from beginners to elites (including Olympian pentathlete Malak Ismail, 2028 LA medalist hopeful)."
          ],
          asAthlete: [
            "2024 Elite African Games (4th place)",
            "2024 Elite Asian Triathlon Cup Champion",
            "2022 Elite Arab Triathlon Champion",
            "World Triathlon Ranking (Best): #85, African Triathlon Ranking (Best): #2",
            "2x Ironman 70.3 Age-Group Podiums"
          ],
          achievements: [
            "Elite international competition experience",
            "Multiple championship titles",
            "Top world and continental rankings"
          ],
          expertise: [
            "Smart training methodologies",
            "Injury prevention and health-first approach",
            "Personalized planning and data-informed coaching"
          ],
          coachingExperience: [
            "Head coach at Podium Racing ME",
            "Personal coach to elite athletes including Olympians",
            "Group training programs for all levels"
          ],
          experience: [
            "Elite international triathlon competitor",
            "Multiple championship titles",
            "World-class ranking achievements"
          ],
          certifications: [
            "USA Triathlon Level I & Long Course Certified",
            "TrainingPeaks Level 1",
            "Basic Life Support & First Aid"
          ],
          philosophy: "Data-informed, not data-dependent – Use data wisely but trust your feel. Health first – No shortcuts that risk long-term well-being. Your goal, your plan – No generic programs. Let's make your next finish line your best one."
        },
        taher: {
          name: "Taher Hesham",
          title: "Triathlon Coach",
          description: "Taher Hesham is a highly skilled triathlon and fitness coach with extensive experience training children, adults, and professional athletes. Since 2020, he has coached at The Trimachine and Fitzone Egypt, guiding athletes to achieve their performance goals through structured training programs, injury prevention strategies, and race preparation.",
          asCoach: [
            "Coached at The Trimachine and Fitzone Egypt since 2020",
            "Guides athletes through structured training programs",
            "Expert in injury prevention strategies and race preparation"
          ],
          asAthlete: [
            "20-time National Champion",
            "2-time Arab Champion",
            "Led team to 1st place in Army Championship"
          ],
          achievements: [
            "Former elite triathlete with firsthand competition experience",
            "Expert knowledge of swim, bike, and run performance",
            "Specialist in endurance training and race strategies"
          ],
          expertise: [
            "Structured training programs",
            "Injury prevention strategies",
            "Race preparation and endurance training"
          ],
          coachingExperience: [
            "Coaching experience since 2020",
            "Training children, adults, and professional athletes",
            "Building strong endurance training culture"
          ],
          experience: [
            "Former elite triathlete",
            "20-time National Champion",
            "2-time Arab Champion"
          ],
          certifications: [
            "Certified through TrainingPeaks",
            "University-level sports science programs",
            "Evidence-based coaching approach"
          ],
          philosophy: "Combining evidence-based coaching with a passion for athlete development, I play a key role in building a strong endurance training culture, helping athletes of all levels unlock their full potential."
        },
        rehab: {
          name: "Rehab Hamdy",
          title: "Triathlon Coach",
          description: "Rehab Hamdy is a dedicated triathlon coach and former elite triathlete with extensive experience in both competitive racing and athlete development. Her journey in endurance sports began as a national-level swimmer, later transitioning into triathlon, where she made history as the first Arab woman to qualify for the Youth Olympic Games (2014). She went on to earn multiple podium finishes at the African Games, WTS Grand Final, and African Triathlon Championships.",
          asCoach: [
            "Founded Root Multisport Academy in 2023",
            "Coached at Stamina Tri Team, Apollo Sports, and AQUATICS Swimming Academy",
            "Works with athletes of all levels, from beginners to elite competitors",
            "Specializes in long-course triathlon coaching for Ironman, national, and international events"
          ],
          asAthlete: [
            "First Arab woman to qualify for the Youth Olympic Games (2014)",
            "Multiple podium finishes at African Games",
            "Podium finishes at WTS Grand Final",
            "African Triathlon Championships podium finisher",
            "Former national-level swimmer"
          ],
          achievements: [
            "Historic achievement as first Arab woman Youth Olympic Games qualifier",
            "Multiple international podium finishes",
            "Successful transition from swimming to triathlon",
            "Academy founder and team leader"
          ],
          expertise: [
            "Swimming, cycling, and running performance training",
            "Individualized training plans",
            "Strategic performance profiling",
            "Athlete race preparation"
          ],
          coachingExperience: [
            "Founded and leads Root Multisport Academy",
            "Coached at multiple prestigious organizations",
            "Mentored age-group and professional athletes",
            "Structured training programs for international events"
          ],
          experience: [
            "Former elite triathlete with international competition experience",
            "National-level swimming background",
            "Multiple championship podium finishes",
            "Academy leadership and team development"
          ],
          certifications: [
            "USAT Level 1 Certified",
            "Training Peaks Level 2 Certified",
            "Long-course triathlon coaching specialist"
          ],
          philosophy: "With expertise in individualized training plans, strategic performance profiling, and athlete race preparation, Rehab is committed to helping athletes reach their full potential. Her passion, leadership, and first-hand competitive experience make her an integral part of the academy's coaching team, inspiring the next generation of endurance athletes."
        },
        saif: {
          name: "Saif Al-Islam",
          title: "Triathlon Coach",
          description: "Saif Al-Islam Al-Hammami is a triathlon coach with strong academic and professional qualifications in sports science. He holds an International Triathlon Coaching Certificate from South Korea, in addition to a specialized certification in athletics, physical preparation, and fitness coach.",
          asCoach: [
            "Coach for the Tunisian National Triathlon Team",
            "Athletics coach for the Military Sports Association",
            "International triathlon referee",
            "Extensive experience in coaching and officiating"
          ],
          asAthlete: [
            "Multiple national medals in athletics",
            "Strong background in sports science",
            "Professional qualifications in athletics and physical preparation"
          ],
          achievements: [
            "International Triathlon Coaching Certificate from South Korea",
            "Multiple national medals as athletics coach",
            "International triathlon referee status",
            "Current coach for Tunisian National Triathlon Team"
          ],
          expertise: [
            "Sports science and academic qualifications",
            "Athletics coaching and physical preparation",
            "International triathlon officiating",
            "National team coaching"
          ],
          coachingExperience: [
            "Current coach for Tunisian National Triathlon Team",
            "Athletics coach for Military Sports Association",
            "International triathlon referee",
            "Extensive coaching and officiating experience"
          ],
          experience: [
            "Strong academic and professional sports science background",
            "Multiple national medals in athletics coaching",
            "International triathlon officiating experience",
            "National team coaching experience"
          ],
          certifications: [
            "International Triathlon Coaching Certificate from South Korea",
            "Specialized certification in athletics, physical preparation, and fitness coach",
            "International triathlon referee certification"
          ],
          philosophy: "With strong academic and professional qualifications in sports science, Saif brings extensive experience in coaching and officiating to help athletes achieve their goals through evidence-based training methods and international standards."
        }
      }
    },
    
    // Athletes Page
    athletes: {
      heroTitle: "Our Athletes",
      heroSubtitle: "Meet the talented triathletes who represent Podium Racing Middle East excellence",
      introText1: "At Podium Racing Middle East (PRME), we welcome both Age Group and Elite athletes to be part of our growing team. As a member, you will officially represent PRME, gaining access to expert coaching, exclusive opportunities, and a driven community that fosters excellence.",
      introText2: "Our mission is to build a strong team of high-performing athletes, continuously pushing limits and reaching new milestones. Be part of something bigger—elevate your athletic journey with PRME!",
      introTagline: "Raising the bar. Shaping champions. Inspiring the future!",
      joinOurTeam: "Join Our Team",
      joinText: "Ready to elevate your triathlon journey? Join Podium Racing Middle East and become part of a community dedicated to excellence, performance, and continuous improvement.",
      benefitsTitle: "Benefits of Joining PRME:",
      benefit1: "Access to world-class coaching",
      benefit2: "Exclusive training opportunities",
      benefit3: "Community of driven athletes",
      benefit4: "Professional development support",
      applyToJoin: "Apply to Join PRME",
      keyAchievements: "Key Achievements:",
      personalBests: "Personal Bests:",
      experience: "Experience:",
      specialties: "Specialties:",
      myPhilosophy: "My Philosophy:",
      
      // Athlete Data Translations
      athletes: {
        seifeldeen: {
          name: "SEIFELDEEN ISMAIL",
          category: "Professional Triathlete",
          achievements: [
            "2x70.3 AG podiums",
            "2022 Arab Champion",
            "2024 Asia Elite Cup Champion"
          ],
          personalBests: [
            "Ironman 70.3: Multiple podiums",
            "Olympic Distance: Regional champion",
            "Sprint Distance: National record holder"
          ],
          experience: [
            "Started triathlon in 2017",
            "International competition experience",
            "Professional racing background"
          ],
          specialties: [
            "Ironman 70.3 racing",
            "Olympic distance optimization",
            "High-intensity training"
          ],
          philosophy: "I believe in pushing boundaries and showing that Middle Eastern athletes can compete at the highest levels internationally. My approach combines strategic training with mental toughness."
        },
        mohamed: {
          name: "MOHAMED HAMADA",
          category: "Age-Group Triathlete",
          achievements: [
            "Multiple Ironman finisher",
            "Age group podium finisher",
            "Regional champion"
          ],
          personalBests: [
            "Ironman 140.6: 9h:11m",
            "Ironman 70.3: 4h:12m",
            "Olympic: 2h:04m"
          ],
          experience: [
            "Started triathlon in 2016",
            "Multiple Ironman finishes",
            "Consistent age group performance"
          ],
          specialties: [
            "Long distance racing",
            "Endurance building",
            "Age group optimization"
          ],
          philosophy: "My focus is on consistent improvement and enjoying the journey. I believe in building endurance gradually and maintaining balance between training and life."
        },
        malik: {
          name: "MALIK ALI",
          category: "Age-Group Triathlete",
          achievements: [],
          personalBests: [
            "Ironman 70.3: Multiple finishes",
            "Multisport events: 40+ races",
            "Marathons: 50+ finishes"
          ],
          experience: [],
          specialties: [],
          philosophy: "I believe in the power of community and consistent participation. My approach focuses on building lasting relationships through shared athletic experiences."
        }
      }
    },
    
    // About Page
    about: {
      heroTitle: "About PRME",
      heroSubtitle: "Connecting athletes with expert coaches across the Middle East",
      ourStory: "Our Story",
      ourStoryContent1: "Podium Racing Team is an international professional triathlon team, featuring seven Olympians including Leo Bergere (who took bronze in Paris), incredible young talent and raw power to fire them to the Teams title.",
      ourStoryContent2: "Podium Racing Founder, John Anthony, said: \"This international roster is composed of the best athletes in our sport while also giving next generation athletes like Fanni Szalai and John Reed the opportunity to compete at the highest level. With Tim Don's leadership, we're bullish about this season.\"",
      ourStoryContent3: "From that, it came the idea to expand this work in the middle east but in a different way fulfilling the need of the middle east sport industry.",
      olympians: "Olympians",
      international: "International",
      professionalTeam: "Professional Team",
      middleEast: "Middle East",
      expansion: "Expansion",
      ourPlatform: "Our Platform",
      platformContent1: "Podium Racing Middle East is an online coaching platform that connects athletes to expert coaches in the sports of SWIM, BIKE, RUN and Triathlon.",
      platformContent2: "As it's one of the main challenges that facing the athletes in the middle east, supporting the athletes by this idea is the main part of our mission.",
      platformContent3: "Inspired by years of experience in the sport of triathlon of our team in Podium Racing Middle East, we will have the most expert sports coaches that you can choose and be connected with to let them guide you in your Sports journey.",
      platformContent4: "As an age grouper or elite or even professional, we will keep expanding in the ME till we reach a high level of support to all the athletes we can reach!!!",
      contactInfo: "Contact Info",
      email: "Email:",
      address: "Address:",
      phone: "Phone:",
      addressValue: "Road 4574, Block 745, Building 2486, Sanad 745"
    },
    
    // Subscription Page
    subscription: {
      heroTitle: "Choose Coach and Join PRME",
      formTitle: "Application Form",
      personalInfoTitle: "Personal & Contact Information",
      fullName: "Full name",
      dateOfBirth: "Date of birth",
      height: "What is your Height (cm)?",
      weight: "What is your Weight (kg)?",
      idealWeight: "What was your Ideal Weight for the last 2-3 years?",
      phoneNumber: "Phone number (Include country code)",
      emailAddress: "Email address",
      cityCountry: "City & Country of Residence",
      maritalStatus: "Marital Status",
      single: "Single",
      married: "Married",
      divorced: "Divorced",
      widowed: "Widowed",
      haveChildren: "Do you have children?",
      yes: "Yes",
      no: "No",
      athleticGoalsTitle: "Athletic Goals",
      ultimateGoal: "What is your ultimate athletic goal in 3-5 years?",
      top3Goals: "What is your top 3 goals for this season?",
      lastSeasonGoal: "What was your top goal last season, and did you achieve it? Why/Why not?",
      importanceScale: "How important (on a scale of 1-10) is achieving these goals to you?",
      whatToGain: "What do you stand to gain by achieving these goals? (Work, self-esteem, family, etc.)",
      trainingLifestyleTitle: "Training Availability & Lifestyle",
      whatLimiting: "What is limiting you from achieving your goals?",
      workTime: "Work Time",
      familyCommitments: "Family Commitments",
      travelTime: "Travel Time",
      motivation: "Motivation",
      injury: "Injury",
      financialLimitations: "Financial Limitations",
      lackOfKnowledge: "Lack of Knowledge/Plan",
      other: "Other",
      otherSpecify: "If you choose Other, please specify",
      workStudyHours: "How many hours per week do you work/study? (Approximately)",
      workStressLevel: "Rate your work stress level (1 = Low, 10 = Very High)",
      availableTrainingSlots: "Available training slots",
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
      fullFlexibility: "Full flexibility",
      sleepSchedule: "Typical Sleep Schedule (Bed time, Wake-up time)",
      currentSkillExperienceTitle: "Current Skill & Experience",
      overallSkillLevel: "Rate your overall skill level (1 = Beginner, 5 = Expert)",
      swimmingSkillLevel: "Swimming Skill Level",
      swimmingHistory: "Briefly describe your swimming history",
      cyclingSkillLevel: "Cycling Skill Level",
      cyclingHistory: "Briefly describe your cycling history",
      runningSkillLevel: "Running Skill Level",
      runningHistory: "Briefly describe your running history",
      trainingEquipmentTitle: "Training Equipment & Technology",
      powerMeter: "Do you train with a power meter? (Yes/No)",
      powerMeterYes: "If yes, what is your typical power output for steady, moderate, and hard efforts?",
      heartRateMonitor: "Do you train with a heart rate monitor? (Yes/No)",
      heartRateMonitorYes: "If yes, what is your average HR for steady, moderate, and hard efforts?",
      trainingEquipment: "Describe your training equipment",
      performancePastRacesTitle: "Performance & Past Races",
      longestDistances: "Longest swim, bike, and run you've completed in the last 6 months:",
      run5K: "5K Run",
      run10K: "10K Run",
      halfMarathon: "Half Marathon",
      marathon: "Marathon",
      swim100m: "100m swim",
      swim200m: "200m swim",
      swim400m: "400m swim",
      swim1K: "1K swim",
      sprintDistance: "Sprint Distance",
      olympicDistance: "Olympic Distance",
      halfIronman: "Half Ironman",
      fullIronman: "Full Ironman",
      vo2MaxTest: "Have you done a VO2 max, lactate threshold, or FTP test? If yes, provide details",
      challengesLimitersTitle: "Challenges & Limiters",
      twoGreatestStrengths: "What are your two greatest strengths in triathlon?",
      twoBiggestLimiters: "What are your two biggest limiters in triathlon?",
      biggestChallenge: "Which of the following challenges you the most?",
      swimEndurance: "Swim endurance",
      swimTechnique: "Swim technique",
      bikeEndurance: "Bike endurance",
      bikePowerHills: "Bike power on hills",
      runEndurance: "Run endurance",
      runSpeed: "Run speed",
      mentalToughness: "Mental toughness",
      medicalInjuryHistoryTitle: "Medical & Injury History",
      pastCurrentInjuries: "Have you had any past or current injuries? (Yes/No)",
      injuryDetails: "If yes, provide details",
      seePhysicalTherapist: "Do you regularly see a physical therapist or sports doctor?",
      chronicInjuriesConditions: "Do you have any chronic injuries or medical conditions? (Yes/No)",
      chronicDetails: "If yes, provide details",
      medicationsSupplements: "Do you take any medications or supplements? (Yes/No)",
      medicationsList: "If yes, list them",
      nutritionRecoveryTitle: "Nutrition & Recovery Habits",
      typicalDayEating: "Describe a typical day of eating (breakfast, lunch, dinner, snacks)",
      dailyWaterIntake: "How much water do you drink daily (excluding exercise)",
      exerciseHydration: "How much hydration do you drink during exercise?",
      foodAllergiesRestrictions: "Do you have any food allergies or dietary restrictions?",
      finalNotesExpectationsTitle: "Final Notes & Expectations",
      whatWantFromCoaching: "What do you truly want from coaching?",
      whatMotivatesAthlete: "What motivates you to be an athlete?",
      biggestTechnicalPhysicalChallenges: "What are your biggest technical & physical challenges?",
      handlePressureRaces: "How do you handle pressure in races?",
      proudAccomplishments: "List 3-5 accomplishments you're really proud of",
      interestedCoach: "Which coach are you interested in?",
      coachSeifeldeen: "Coach Seifeldeen Ismail",
      coachSaif: "Coach Saif Al- Hammami",
      coachTaher: "Coach Taher Hesham",
      coachRehab: "Coach Rehab Hamdy",
      needCallHeadCoach: "Do you need to arrange a call with our head coach to discuss further detail?",
      yesNeedCall: "Yes, I need a call",
      noReadyStart: "No, I think am ready to start!",
      anythingElse: "Anything else I should know?",
      beginner: "Beginner",
      intermediate: "Intermediate",
      advanced: "Advanced",
      expert: "Expert",
      next: "Next",
      previous: "Previous",
           submit: "Submit Application",
           submitting: "Submitting...",
           successMessage: "Thank you! Your application has been submitted successfully.",
           errorMessage: "Sorry, there was an error submitting your application. Please try again.",
      validationRequired: "Validation Required",
      completeCurrentSection: "Please complete the current section before proceeding to the next section.",
      fillRequiredFields: "Please fill in all required fields in the current section before proceeding.",
      ageDisplay: "Age: {age} years old",
      selected: "Selected:",
      notImportant: "Not Important",
      moderatelyImportant: "Moderately Important",
      low: "Low",
      moderate: "Moderate",
      veryHigh: "Very High",
      fieldHeight: "Height",
      fieldWeight: "Weight",
      fieldIdealWeight: "Ideal Weight",
      mustBePositive: "{field} must be a positive number",
      validEmail: "Please enter a valid email address",
      mustBe15: "You must be at least 15 years old to apply",
      ok: "OK"
    },
    
    // Footer
    footer: {
      companyName: "Podium Racing Middle East",
      tagline: "Your premier destination for high-performance racing experiences.",
      quickLinks: "Quick Links",
      home: "Home",
      coaches: "Coaches",
      athletes: "Athletes",
      aboutUs: "About Us",
      copyright: "© 2025 Podium Racing Middle East. All rights reserved.",
      developedBy: "Developed and sponsor by PMI"
    }
  },
  
  ar: {
    // Navigation
    nav: {
      home: "الرئيسية",
      coaches: "المدربين",
      athletes: "الرياضيين",
      about: "من نحن",
      joinUs: "انضم الى PR ME"
    },
    
    // Home Page
    home: {
      heroTitle: "PODIUM RACING MIDDLE EAST",
      heroSubtitle: "انضم الى PR ME",
      joinOurTribe: "انضم الى PR ME",
      meetOurCoaches: "مدربين PR ME",
      movingBar: [
        "تمكن من قدراتك",
        "تدرب بقوة – أشرق بقوة",
        "خطوة واحدة اليوم – تطور كبير غداً",
        "من العمل إلى النجاح – نحن معك",
        "تسابق بقوه",
        "أقوى في كل تدريب – أقرب لكل هدف",
        "حول الجهد إلى نجاح",
        "رحلتك – مهمتنا",
        "مدفوع بالشغف"
      ],
      vision: "الرؤية",
      visionContent1: "في Podium Racing الشرق الأوسط، رؤيتنا هي تنمية فريق من الرياضيين عالي الأداء على مستوى الناشئين والهواة والنخبة والمحترفين في جميع أنحاء المنطقة. من خلال دمج منهجيات التدريب العالمية من Podium Racing الولايات المتحدة، نسعى لرفع  التنافس في الشرق الأوسط، وإعداد الرياضيين للتميز على المستوى الدولي.",
      visionContent2: "التزامنا يمتد إلى ما هو أبعد من الأداء - نهدف إلى تعزيز ثقافة التميز والروح الرياضية ومشاركة الثقافه، مما يضمن أن كل رياضي لا يصل فقط إلى إمكانياته العاليه بل يساهم أيضاً في تطور أخلاقيات الرياضة في المنطقة.",
      visionContent3: "رفع الأداء الرياضي . صناعه الابطال",
      mission: "المهمة",
      missionContent1: "في Podium Racing الشرق الأوسط، مهمتنا هي تسهيل وصول  الرياضيين إلى المدربين  في   الشرق الأوسط. سواء كنت تبحث عن تدريب في الرياضات المتعدده  أو تدريب متخصص في السباحة أو ركوب الدراجات أو الجري ، فإننا نسهل وصولك بأكثر المدربين تأهيلاً لرفع أدائك الرياضي.",
      missionContent2: "من خلال الشراكة مع المدربين الخبراء الذين يتبعون أعلى المعايير في علوم الرياضة ومنهجيات التدريب، نضمن ان كل رياضي يحصل على التوجيه والتدريب  المخصص الذي يحتاجه للوصول إلى افضل اداء رياضي.",
      missionContent3: "الوصول بك إلى أعلى اداء راضي",
      whatWeOffer: "ما نقدمه",
      swim: "السباحة",
        swimDesc: "اتقان السباحة مع التدريب والاخبره",
      bike: "ركوب الدراجات",
      bikeDesc: "تطوير مهارات ركوب الدراجات والقدره على التحمل",
      run: "الجري",
      runDesc: "تحسين تقنيه الجري",
      triathlon: "الترايثلون",
      triathlonDesc: "التدريب لعمل سباق ترايثلون بالامسافات المختلفه بافضل اداء رياضي",
      quote: "الرياضه تعلمنا أن نتحدى أنفسنا. تعلمنا أن ندفع انفسنا دائما للامام. تساعدنا على اكتشاف قدراتنا.",
      quoteAuthor: "Podium Racing الشرق الأوسط",
      joinOurTribeTitle: "انضم إلى PR ME",
      joinContent: "مستعد لبدء رحلتك الراضيه الناجحه ؟ انضم إلى Podium Racing الشرق الأوسط وكن جزءاً من مجتمع متميز.",
      applyToJoin: "انضم الى PR ME"
    },
    
    // Coaches Page
    coaches: {
      heroTitle: "المدربين",
      heroSubtitle: "تعرفوا على فريق مدربين PRME",
      coachingPrograms: "برامج التدريب",
      beginnerProgram: "برنامج المبتدئين",
      beginnerDescription: "مثالي لمن هم جدد في السباق. تعلم الأساسيات وبروتوكولات السلامة وتقنيات السباق الأساسية.",
      intermediateProgram: "برنامج المتوسطين",
      intermediateDescription: "للعدائين ذوي الخبرة الذين يتطلعون إلى تحسين المهارات والأداء في المضمار.",
      eliteProgram: "برنامج النخبة",
      eliteDescription: "تدريب مكثف للعدائين التنافسيين الذين يهدفون إلى مهن السباق المهنية.",
      safetyFundamentals: "أساسيات السلامة",
      basicRacingTechniques: "تقنيات السباق الأساسية",
      equipmentFamiliarization: "التعرف على المعدات",
      tipsForBetterTechnique: "نصائح لتقنية أفضل",
      advancedTechniques: "تقنيات متقدمة",
      performanceOptimization: "تحسين الأداء",
      strategyDevelopment: "تطوير الاستراتيجية",
      competitionPreparation: "التحضير للمنافسة",
      professionalTechniques: "تقنيات مهنية",
      mentalConditioning: "التكييف العقلي",
      advancedStrategy: "استراتيجية متقدمة",
      careerDevelopment: "تطوير المسيرة المهنية",
      asACoach: "كمدرب:",
      asAnAthlete: "كرياضي:",
      achievements: "الإنجازات:",
      expertise: "الخبرة:",
      coachingExperience: "خبرة التدريب:",
      experience: "الخبرة:",
      certifications: "الشهادات:",
      myPhilosophy: "فلسفتي:",
      
      // Coach Data Translations
      coaches: {
        seifeldeen: {
          name: "سيف الدين إسماعيل",
          title: "مدرب ثلاثي ترايثلون محترف",
          description: "أساعد الرياضيين من جميع المستويات على تحقيق أهدافهم بشكل أسرع، وتجنب الإصابات، والاستمتاع برحلة التطور الرياضي. يعتمد أسلوبي التدريبي على التخطيط الصحيح، وليس فقط وضع الأحمال والإجهاد. أدمج بين العلم والخبرة الرياضية والخطط المخصصة لكل لاعب لأن التقدم الحقيقي يجب أن يكون مستدامًا… ليس مرهقًا.",
          asCoach: [
            "دّربت رياضيين تأ ّهلوا لبطولة العالم الرجل الحديدي.70.3",
            "قُدّت أحد الناجين من اللوكيميا إلكمال 4 سباقات 70.3 وسباق آيرون مان كامل خالل عامين فقط, مع تحقيق أرقام شخصية.",
            "أعمل مع جميع المستويات، من المبتدئين إلى النخبة )بما في ذلك بطلة الخماسي األولمبي ملك إسماعيل، المر ّشحة لحصد ميدالية في أولمبياد لوس أنجلوس 2028(."
          ],
          asAthlete: [
            "المركز الرابع في ألعاب أفريقيا للنخبة 2024",
            "بطل كأس آسيا للنخبة في التراياثلون 2024",
            "بطل العرب للنخبة في التراياثلون 2022",
            "أفضل تصنيف عالمي في االتحاد الدولي للتراياثلون 85#",
            "أفضل تصنيف أفريقي: 2#",
            "الوصول مرتين الى منصة التتويج في سباق الر جل الحديدي 70.3 Ironman"
          ],
          achievements: [
            "خبرة في المنافسة الدولية النخبة",
            "عناوين بطولة متعددة",
            "أفضل ترتيبات عالمية وقارية"
          ],
          expertise: [
            "منهجيات التدريب الذكية",
            "منع الإصابات والنهج القائم على الصحة أولاً",
            "التخطيط الشخصي والتدريب القائم على البيانات"
          ],
          coachingExperience: [
            "المدرب الرئيسي في Podium Racing ME",
            "مدرب شخصي للرياضيين النخبة بما في ذلك الأولمبيين",
            "برامج التدريب الجماعي لجميع المستويات"
          ],
          experience: [
            "منافس الترايثلون الدولي النخبة",
            "عناوين بطولة متعددة",
            "إنجازات ترتيب عالمي"
          ],
          certifications: [
            "مدّرب معتمد من Triathlon USA( المستوى األول - تخصص المسافات الطويلة(",
            "TrainingPeaks Level 1 شهادة",
            "معتمد في اإلسعافات األولية واإلنعاش القلبي الرئوي –BLS"
          ],
          philosophy: "مبني على فهم وقراءه البيانات , واستخدام البيانات بشكل صحيح مبني على خبره االعب. التطور الممنهج الذي ال يعرض االعب لخطر اإلصابات. هدف الالعب مخصص لالعب , خطه تدريب االعب مخصصه أيضا لالعب , ال استخدم تمارين عامه. لنصنع افضل أداء رياضي لك بخطه مخصصه."
        },
        taher: {
          name: "طاهر هشام",
          title: "مدرب ترايثلون",
          description: "طاهر هشام – مدرب ترايثلون. طاهر هشام مدرب ترايثلون ولياقة بدنية متمرس، يمتلك خبرة واسعة في تدريب الأطفال، البالغين، والرياضيين المحترفين. منذ عام 2020، عمل طاهر في The Trimachine و Fitzone Egypt، حيث قاد الرياضيين لتحقيق أهداف أدائهم من خلال برامج تدريب منظمة، استراتيجيات الوقاية من الإصابات، والتحضير للمسابقات. لاعب ترايثلون متميز، فاز طاهر بـ 20 بطولة وطنية وبطولتين عربيتين، وقاد فريقه للفوز بالمركز الأول في بطولة الجيش. تمنحه خبرته المباشرة على أعلى مستويات المنافسة القدرة على توجيه الرياضيين بمعرفة متعمقة في السباحة، ركوب الدراجات، الجري، التدريب على التحمل، واستراتيجيات السباق. معتمد من TrainingPeaks وبرامج علوم الرياضة، يجمع طاهر بين التدريب القائم على الأدلة وشغفه بتطوير الرياضيين. في الأكاديمية، يلعب دورًا رئيسيًا في بناء ثقافة قوية للتدريب على التحمل، ومساعدة الرياضيين من جميع المستويات على الوصول إلى كامل إمكاناتهم.",
          asCoach: [
            "درّب في The Trimachine وFitzone Egypt منذ عام 2020",
            "يقود الرياضيين من خلال برامج التدريب المنظمة",
            "خبير في استراتيجيات منع الإصابات والتحضير للسباق"
          ],
          asAthlete: [
            "بطل وطني 20 مرة",
            "بطل عربي مرتين",
            "قاد الفريق للمركز الأول في بطولة الجيش"
          ],
          achievements: [
            "رياضي ترايثلون نخبة سابق مع خبرة منافسة مباشرة",
            "معرفة خبيرة في أداء السباحة وركوب الدراجات والجري",
            "متخصص في تدريب التحمل واستراتيجيات السباق"
          ],
          expertise: [
            "برامج التدريب المنظمة",
            "استراتيجيات منع الإصابات",
            "التحضير للسباق وتدريب التحمل"
          ],
          coachingExperience: [
            "خبرة تدريب منذ عام 2020",
            "تدريب الأطفال والبالغين والرياضيين المحترفين",
            "بناء ثقافة تدريب التحمل القوية"
          ],
          experience: [
            "رياضي ترايثلون نخبة سابق",
            "بطل وطني 20 مرة",
            "بطل عربي مرتين"
          ],
          certifications: [
            "معتمد من خلال TrainingPeaks",
            "برامج علوم الرياضة على مستوى الجامعة",
            "نهج تدريب قائم على الأدلة"
          ],
          philosophy: "بدمج التدريب القائم على الأدلة مع شغف تطوير الرياضيين، ألعب دوراً رئيسياً في بناء ثقافة تدريب التحمل القوية، مما يساعد الرياضيين من جميع المستويات على إطلاق إمكاناتهم الكاملة."
        },
        rehab: {
          name: "رحاب حمدي",
          title: "مدربة ترايثلون",
          description: "رحاب حمدي مدربة ترايثلون ورياضية سباقة من فئة النخبة، تمتلك خبرة واسعة في كل من السباقات التنافسية وتطوير الرياضيين. بدأت رحلتها في رياضات التحمل كسبّاحة على المستوى الوطني، ثم انتقلت إلى رياضة الترايثلون، حيث صنعت التاريخ كأول امرأة عربية تتأهل للألعاب الأولمبية للشباب (2014)، وواصلت رحاب مسيرتها بتحقيق منصات تتويج في الألعاب الأفريقية، وبطولات WITS الإنجليزي، وبطولات أفريقيا للترايثلون. تتمتع Rehab بخبرة واسعة في التدريب على السباحة وركوب الدراجات والجري، وعملت مع رياضيين من مختلف المستويات، بدءًا من المبتدئين وحتى المنافسين من فئة النخبة، مع التركيز على التقنية والقدرة على التحمل والتحضير للمسابقات. شغلت منصب مدربة ثلاثيات في Stamina Tri Team و Apollo Sports & Aquatics و Swimming Academy، حيث قامت بتوجيه الرياضيين المحترفين ورياضيي الفئات العمرية على حد سواء لتحقيق أقصى إمكانياتهم. في عام 2023، أسست Rehab أكاديمية Root Multisport، حيث تقود فريقًا من رياضيي الثلاثيات من خلال برامج تدريبية منظمة تهدف إلى تحقيق أفضل أداء في سباقات Ironman والمنافسات المحلية والدولية. متخصصة في تدريب الترايثلون لمسافات طويلة، وحاصلة على شهادتي TrainingPeaks Level 2 و USAT Level 1. تمتلك Rehab خبرة واسعة في إعداد برامج تدريبية فردية، وتحليل الأداء الاستراتيجي، والتحضير للمسابقات متعددة التخصصات، مع تركيز قوي على مساعدة الرياضيين على تحقيق كامل إمكانياتهم. شغفها وخبرتها العملية في المنافسات تجعلها عنصرًا أساسيًا في فريق التدريب بالأكاديمية، وملهمة للجيل القادم من رياضيي التحمل.",
          asCoach: [
            "أسست أكاديمية Root Multisport في عام 2023",
            "درّبت في Stamina Tri Team وApollo Sports وAQUATICS Swimming Academy",
            "تعمل مع الرياضيين من جميع المستويات، من المبتدئين إلى المنافسين النخبة",
            "تتخصص في تدريب الترايثلون للمسافات الطويلة للحديد والبطولات الوطنية والدولية"
          ],
          asAthlete: [
            "أول امرأة عربية تتأهل للألعاب الأولمبية للشباب (2014)",
            "منصات متعددة في الألعاب الأفريقية",
            "منصات في WTS Grand Final",
            "حاصلة على منصة في بطولات الترايثلون الأفريقية",
            "سباحة على المستوى الوطني سابقاً"
          ],
          achievements: [
            "إنجاز تاريخي كأول امرأة عربية تتأهل للألعاب الأولمبية للشباب",
            "منصات دولية متعددة",
            "انتقال ناجح من السباحة إلى الترايثلون",
            "مؤسسة أكاديمية وقائدة فريق"
          ],
          expertise: [
            "تدريب أداء السباحة وركوب الدراجات والجري",
            "خطط التدريب الفردية",
            "تحليل الأداء الاستراتيجي",
            "تحضير الرياضيين للسباق"
          ],
          coachingExperience: [
            "أسست وتقود أكاديمية Root Multisport",
            "درّبت في منظمات مرموقة متعددة",
            "أرشدت الرياضيين من الفئات العمرية والمحترفين",
            "برامج تدريب منظمة للأحداث الدولية"
          ],
          experience: [
            "رياضية ترايثلون نخبة سابقة مع خبرة منافسة دولية",
            "خلفية سباحة على المستوى الوطني",
            "منصات بطولة متعددة",
            "قيادة أكاديمية وتطوير فريق"
          ],
          certifications: [
            "معتمدة USAT المستوى 1",
            "معتمدة Training Peaks المستوى 2",
            "متخصصة في تدريب الترايثلون للمسافات الطويلة"
          ],
          philosophy: "مع الخبرة في خطط التدريب الفردية وتحليل الأداء الاستراتيجي وتحضير الرياضيين للسباق، رحاب ملتزمة بمساعدة الرياضيين على الوصول إلى إمكاناتهم الكاملة. شغفها وقيادتها وخبرتها التنافسية المباشرة تجعلها جزءاً لا يتجزأ من فريق التدريب في الأكاديمية، مما يلهم الجيل القادم من رياضيين التحمل."
        },
        saif: {
          name: "سيف الإسلام الهمامي",
          title: "مدرب ترايثلون معتمد",
          description: "سيف الإسلام الهمامي – مدرب ترايثلون معتمد. سيف الإسلام الهمامي هو مدرب ترايثلون يتمتع بمؤهلات أكاديمية ومهنية قوية في علوم الرياضة، حاصل على شهادة المدرب الدولي للترايثلون من كوريا الجنوبية، بالإضافة إلى شهادة متخصصة في ألعاب القوى، والإعداد البدني، وتدريب اللياقة البدنية. يمتلك سيف الإسلام خبرة واسعة في التدريب والتحكيم، حيث شغل منصب مدرب ألعاب القوى في الجمعية الرياضية العسكرية، وحقق مع الرياضيين العديد من الميداليات الوطنية. كما يعمل كحكم دولي في رياضة الثلاثيات، ويشغل حاليًا منصب مدرب فريق تونس الوطني للثلاثيات.",
          asCoach: [
            "مدرب لفريق الترايثلون الوطني التونسي",
            "مدرب ألعاب القوى لجمعية الرياضة العسكرية",
            "حكم ترايثلون دولي",
            "خبرة واسعة في التدريب والحكم"
          ],
          asAthlete: [
            "ميداليات وطنية متعددة في ألعاب القوى",
            "خلفية قوية في علوم الرياضة",
            "مؤهلات مهنية في ألعاب القوى والتحضير البدني"
          ],
          achievements: [
            "شهادة تدريب الترايثلون الدولية من كوريا الجنوبية",
            "ميداليات وطنية متعددة كمدرب ألعاب القوى",
            "حالة حكم ترايثلون دولي",
            "مدرب حالي لفريق الترايثلون الوطني التونسي"
          ],
          expertise: [
            "مؤهلات علوم الرياضة والأكاديمية",
            "تدريب ألعاب القوى والتحضير البدني",
            "حكم الترايثلون الدولي",
            "تدريب الفريق الوطني"
          ],
          coachingExperience: [
            "مدرب حالي لفريق الترايثلون الوطني التونسي",
            "مدرب ألعاب القوى لجمعية الرياضة العسكرية",
            "حكم ترايثلون دولي",
            "خبرة واسعة في التدريب والحكم"
          ],
          experience: [
            "خلفية قوية في علوم الرياضة الأكاديمية والمهنية",
            "ميداليات وطنية متعددة في تدريب ألعاب القوى",
            "خبرة حكم ترايثلون دولية",
            "خبرة تدريب الفريق الوطني"
          ],
          certifications: [
            "شهادة تدريب الترايثلون الدولية من كوريا الجنوبية",
            "شهادة متخصصة في ألعاب القوى والتحضير البدني ومدرب اللياقة البدنية",
            "شهادة حكم الترايثلون الدولية"
          ],
          philosophy: "مع المؤهلات الأكاديمية والمهنية القوية في علوم الرياضة، يجلب سيف خبرة واسعة في التدريب والحكم لمساعدة الرياضيين على تحقيق أهدافهم من خلال طرق التدريب القائمة على الأدلة والمعايير الدولية."
        }
      }
    },
    
    // Athletes Page
    athletes: {
      heroTitle: "رياضيين PR ME",
      heroSubtitle: "تعرفوا على فريق رياضيين PRME",
      introText1: "في PRME، نرحب بكل من الرياضيين في الفئات العمرية المختلفة والرياضيين النخبة للانضمام إلى فريقنا. كعضو في PRME، ستمثل علامتنا رسميًا، وستحصل على تدريب احترافي، وفرص حصرية، ومجتمع ديناميكي يركز على التميز.",
      introText2: "مهمتنا بسيطة: بناء فريق من الرياضيين المتميزين الذين يتطورون باستمرار ويحققون إنجازات جديدة. انضم إلينا وكن جزءًا من الفريق – ارتقِ برحلتك الرياضية مع PRME.",
      introTagline: "رفع المستوى. تشكيل الأبطال. إلهام المستقبل!",
      joinOurTeam: "انضم إلى فريقنا",
      joinText: "مستعد لبدايه جديده في رياضه الترايثلون ؟ انضم إلى Podium Racing الشرق الأوسط وكن جزءاً من مجتمع مكرس للتميز والأداء والتحسين المستمر.",
      benefitsTitle: "فوائد الانضمام إلى PRME:",
      benefit1: "الوصول إلى التدريب العالمي",
      benefit2: "فرص تدريب حصرية",
      benefit3: "مجتمع من الرياضيين المحفزين",
      benefit4: "دعم التطوير المهني",
      applyToJoin: "انضم الى PR ME",
      keyAchievements: "الإنجازات الرئيسية:",
      personalBests: "أفضل الأرقام الشخصية:",
      experience: "الخبرة:",
      specialties: "التخصصات:",
      myPhilosophy: "فلسفتي:",
      
      // Athlete Data Translations
      athletes: {
        seifeldeen: {
          name: "سيف الدين إسماعيل",
          category: "رياضي ترايثلون محترف",
          achievements: [
            "2 منصة فئة عمرية 70.3",
            "بطل عربي 2022",
            "بطل كأس آسيا النخبة 2024"
          ],
          personalBests: [
            "Ironman 70.3: منصات متعددة",
            "المسافة الأولمبية: بطل إقليمي",
            "المسافة السريعة: حامل الرقم القومي"
          ],
          experience: [
            "بدأ الترايثلون في 2017",
            "خبرة في المنافسة الدولية",
            "خلفية في السباق المحترف"
          ],
          specialties: [
            "سباق Ironman 70.3",
            "تحسين المسافة الأولمبية",
            "التدريب عالي الكثافة"
          ],
          philosophy: "أؤمن بدفع الحدود وإظهار أن الرياضيين من الشرق الأوسط يمكنهم المنافسة على أعلى المستويات دولياً. نهجي يجمع بين التدريب الاستراتيجي والقوة العقلية."
        },
        mohamed: {
          name: "محمد حمادة",
          category: "رياضي ترايثلون فئة عمرية",
          achievements: [
            "عدة إنهاءات للحديد",
            "حاصل على منصة فئة عمرية",
            "بطل إقليمي"
          ],
          personalBests: [
            "الحديد 140.6: 9س:11د",
            "Ironman 70.3: 4س:12د",
            "أولمبي: 2س:04د"
          ],
          experience: [
            "بدأ الترايثلون في 2016",
            "عدة إنهاءات للحديد",
            "أداء ثابت في الفئة العمرية"
          ],
          specialties: [
            "سباق المسافات الطويلة",
            "بناء التحمل",
            "تحسين الفئة العمرية"
          ],
          philosophy: "تركيزي على التحسين المستمر والاستمتاع بالرحلة. أؤمن ببناء التحمل تدريجياً والحفاظ على التوازن بين التدريب والحياة."
        },
        malik: {
          name: "مالك علي",
          category: "رياضي ترايثلون فئة عمرية",
          achievements: [],
          personalBests: [
            "Ironman 70.3: عدة إنهاءات",
            "أحداث متعددة الرياضات: 40+ سباق",
            "الماراثون: 50+ إنهاء"
          ],
          experience: [],
          specialties: [],
          philosophy: "أؤمن بقوة المجتمع والمشاركة المستمرة. نهجي يركز على بناء علاقات دائمة من خلال التجارب الرياضية المشتركة."
        }
      }
    },
    
    // About Page
    about: {
      heroTitle: "من نحن",
      heroSubtitle: "توصل الرياضيين بأفضل المدربين الدوليين في الوطن العربي",
      ourStory: "قصة PRME",
      ourStoryContent1: "فريق بوديوم ريسينغ هو فريق ثلاثي احترافي دولي، يضم سبعة من الأولمبيين بما في ذلك ليو بيرجير (الحائز على الميدالية البرونزية في باريس)، إلى جانب مواهب شابة مذهلة وقوة خام تدفعهم نحو لقب الفريق.",
      ourStoryContent2: "قال مؤسس بوديوم ريسينغ، جون أنطوني: \"تتنافس هذه التشكيلة الدولية من أفضل الرياضيين في رياضتنا، وفي الوقت نفسه تمنح الفرصة للجيل القادم من الرياضيين مثل فاني سزيليو وجون بيرد للمنافسة على أعلى مستوى. مع قيادة تيم دون، نحن متفائلون جدًا بشأن هذا الموسم.\"",
      ourStoryContent3: "ومن هذا الإطار، جاءت فكرة توسيع هذا العمل في منطقة الشرق الأوسط بطريقة مختلفة، تلبي احتياجات صناعة الرياضة في المنطقة.",
      olympians: "أولمبيون",
      international: "دولي",
      professionalTeam: "فريق محترف",
      middleEast: "الشرق الأوسط",
      expansion: "توسع",
      ourPlatform: "منصة PRME",
      platformContent1: "بوديوم ريسينغ هي منصة تدريبية إلكترونية تربط الرياضيين بأفضل المدربين في رياضات السباحة، الدراجة، الجري، والثلاثي (ترايثلون) واللياقة البدنية.",
      platformContent2: "نظرًا لأن أحد أبرز التحديات التي يواجهها الرياضيون في منطقة الشرق الأوسط هو الوصول إلى تدريب متخصص واحترافي، فإن دعم الرياضيين من خلال هذه الفكرة يمثل الجزء الأساسي من مهمتنا.",
      platformContent3: "استنادًا إلى سنوات الخبرة في رياضة الترايثلون التي يتمتع بها فريقنا في بوديوم ريسينغ، سنوفر لك أفضل المدربين المتخصصين الذين يمكنك اختيارهم والتواصل معهم لتوجيهك في رحلتك الرياضية.",
      platformContent4: "سواء كنت رياضيًا في الفئات العمرية، نخبة، أو محترفًا، سنواصل التوسع في منطقة الشرق الأوسط حتى نوفر أعلى مستوى من الدعم لكل الرياضيين الذين يمكننا الوصول إليهم!",
      contactInfo: "معلومات الاتصال",
      email: "البريد الإلكتروني:",
      address: "العنوان:",
      phone: "الهاتف:",
      addressValue: "طريق 4574، مجمع 745، مبنى 2486، سند 745"
    },
    
    // Subscription Page
    subscription: {
      heroTitle: "اختر مدرب وانضم إلى PRME",
      formTitle: "نموذج الطلب",
      personalInfoTitle: "المعلومات الشخصية",
      fullName: "الاسم بالكامل",
      dateOfBirth: "تاريخ الميلاد",
      height: "كم طولك (سم)؟",
      weight: "كم وزنك (كج)؟",
      idealWeight: "كم وزنك المثالي علي مدار اخر سنتين او ثلاثة؟",
      phoneNumber: "رقم الهاتف (شامل كود البلد)",
      emailAddress: "البريد الالكتروني",
      cityCountry: "مدينة و بلد الاقامة",
      maritalStatus: "الحالة الاجتماعية",
      single: "اعزب",
      married: "متزوج",
      divorced: "مطلق",
      widowed: "أرمل",
      haveChildren: "هل لديك ابناء؟",
      yes: "نعم",
      no: "لا",
      athleticGoalsTitle: "الاهداف الرياضية",
      ultimateGoal: "ما هي اهدافك الرياضية الكبري علي مدار 3-5 سنوات؟",
      top3Goals: "ما هي اهم 3 اهراف لك هذا الموسم؟",
      lastSeasonGoal: "ما هي اهدافك للموسم الماضي, هل حققتها؟ ما السبب وراء ذلك؟",
      importanceScale: "ما مدي اهمية تحقيق تلك الاهداف (علي مقياس 1-10)؟",
      whatToGain: "ما الذي ستجنيه من تحقيق هذه الأهداف؟ (العمل، احترام الذات، الأسرة، إلخ.)",
      trainingLifestyleTitle: "توفّر التدريب ونمط الحياة",
      whatLimiting: "ما الذي يمنعك من تحقيق أهدافك؟",
      workTime: "وقت العمل",
      familyCommitments: "الالتزامات عائلية",
      travelTime: "وقت السفر",
      motivation: "الدافع",
      injury: "الإصابة",
      financialLimitations: "القيود المالية",
      lackOfKnowledge: "نقص المعرفة / الخطة",
      other: "أخرى",
      otherSpecify: "إذا اخترت \"أخرى\"، يرجى التوضيح",
      workStudyHours: "كم عدد الساعات التي تعمل أو تدرس فيها أسبوعيًا (تقريبًا)؟",
      workStressLevel: "قيّم مستوى التوتر الناتج عن العمل (1 = منخفض، 10 = عالٍ جدًا)",
      availableTrainingSlots: "ما الأوقات المتاحة لديك للتدريب؟",
      monday: "الاثنين",
      tuesday: "التلات",
      wednesday: "الاربع",
      thursday: "الخميس",
      friday: "الجمعة",
      saturday: "السبت",
      sunday: "الحد",
      fullFlexibility: "مرونة كاملة",
      sleepSchedule: "ما هو جدول نومك المعتاد؟ (وقت النوم ووقت الاستيقاظ)",
      currentSkillExperienceTitle: "المهارات الحالية والخبرة",
      overallSkillLevel: "قيّم مستواك العام في الرياضة (1 = مبتدئ، 5 = محترف)",
      swimmingSkillLevel: "مستوى مهارتك في السباحة",
      swimmingHistory: "صف بإيجاز تاريخك في السباحة",
      cyclingSkillLevel: "مستوى مهارتك في ركوب الدراجات",
      cyclingHistory: "صف بإيجاز تاريخك في ركوب الدراجات",
      runningSkillLevel: "مستوى مهارتك في الجري",
      runningHistory: "صف بإيجاز تاريخك في الجري",
      trainingEquipmentTitle: "معدات التدريب والتكنولوجيا",
      powerMeter: "هل تتدرب باستخدام جهاز قياس القوة (باور ميتر)؟ (نعم/لا)",
      powerMeterYes: "إذا كانت الإجابة نعم، ما هو ناتجك المعتاد في الجهد المتوسط والعالي؟",
      heartRateMonitor: "هل تتدرب باستخدام جهاز مراقبة نبضات القلب؟ (نعم/لا)",
      heartRateMonitorYes: "إذا كانت الإجابة نعم، ما هو متوسط نبضك في الجهد المتوسط والعالي؟",
      trainingEquipment: "صف معداتك التدريبية",
      performancePastRacesTitle: "الأداء والسباقات السابقة",
      longestDistances: "أطول مسافات سباحة، دراجة، وجري قمت بها خلال آخر 6 شهور",
      run5K: "5K Run",
      run10K: "10K Run",
      halfMarathon: "Half Marathon",
      marathon: "Marathon",
      swim100m: "100m swim",
      swim200m: "200m swim",
      swim400m: "400m swim",
      swim1K: "1K swim",
      sprintDistance: "Sprint Distance",
      olympicDistance: "Olympic Distance",
      halfIronman: "Half Ironman",
      fullIronman: "Full Ironman",
      vo2MaxTest: "هل اجريت اختبارات ال VO2 MAX او عتبة اللاكتات FTP او قياس ال اذا نعم يرجي تقديم التفاصيل",
      challengesLimitersTitle: "التحديات والمعوقات",
      twoGreatestStrengths: "ما هما أقوى نقطتين لديك في رياضة الترايثلون؟",
      twoBiggestLimiters: "ما هما أكبر نقطتي ضعف لديك في الترايثلون؟",
      biggestChallenge: "ما هو التحدي الأكبر بالنسبة لك من بين التالي؟",
      swimEndurance: "التحمل في السباحة",
      swimTechnique: "تكنيك السباحة",
      bikeEndurance: "التحمل في الدراجة",
      bikePowerHills: "القوة في الصعود",
      runEndurance: "التحمل في الجري",
      runSpeed: "السرعة في الجري",
      mentalToughness: "القوة الذهنية",
      medicalInjuryHistoryTitle: "السجل الطبي والإصابات",
      pastCurrentInjuries: "هل لديك إصابات حالية أو سابقة؟ (نعم/لا)",
      injuryDetails: "إذا كانت الإجابة نعم، يرجى تقديم التفاصيل",
      seePhysicalTherapist: "هل تزور طبيب علاج طبيعي أو طبيب رياضي بانتظام؟",
      chronicInjuriesConditions: "هل لديك أي إصابات مزمنة أو حالات طبية؟ (نعم/لا)",
      chronicDetails: "إذا كانت الإجابة نعم، يرجى التوضيح",
      medicationsSupplements: "هل تتناول أي أدوية أو مكملات؟ (نعم/لا)",
      medicationsList: "إذا كانت الإجابة نعم، يرجى ذكره",
      nutritionRecoveryTitle: "العادات الغذائية والتعافي",
      typicalDayEating: "صف يومك الغذائي المعتاد (فطور، غداء، عشاء، وجبات خفيفة)",
      dailyWaterIntake: "كم كمية الماء التي تشربها يوميًا (باستثناء أثناء التمرين)",
      exerciseHydration: "كم كمية السوائل التي تشربها أثناء التمرين؟",
      foodAllergiesRestrictions: "هل لديك أي حساسية غذائية أو قيود في نظامك الغذائي؟",
      finalNotesExpectationsTitle: "ملاحظاتك وتوقعاتك النهائية",
      whatWantFromCoaching: "ماذا تريد من التدريب والإشراف الرياضي؟",
      whatMotivatesAthlete: "ما الذي يحفزك لتكون رياضيًا؟",
      biggestTechnicalPhysicalChallenges: "ما هي أكبر التحديات التقنية والبدنية التي تواجهها؟",
      handlePressureRaces: "كيف تتعامل مع الضغط في السباقات؟",
      proudAccomplishments: "اذكر 3 إلى 5 إنجازات تفتخر بها حقًا",
      interestedCoach: "أي من المدربين تهتم بالعمل معه؟",
      coachSeifeldeen: "المدرب سيف الدين إسماعيل",
      coachSaif: "المدرب سيف الحمامي",
      coachTaher: "المدرب طاهر هشام",
      coachRehab: "المدربة رحاب حمدي",
      needCallHeadCoach: "هل تحتاج إلى تحديد مكالمة مع المدرب الرئيسي لمزيد من التفاصيل؟",
      yesNeedCall: "نعم، أحتاج مكالمة",
      noReadyStart: "لا، أعتقد أنني جاهز للبدء!",
      anythingElse: "هل هناك أي شيء آخر يجب أن أعرفه؟",
      beginner: "مبتدئ",
      intermediate: "متوسط",
      advanced: "متقدم",
      expert: "محترف",
      next: "التالي",
      previous: "السابق",
           submit: "إرسال الطلب",
           submitting: "جاري الإرسال...",
           successMessage: "شكراً لك! تم إرسال طلبك بنجاح.",
           errorMessage: "عذراً، حدث خطأ في إرسال طلبك. يرجى المحاولة مرة أخرى.",
      validationRequired: "التحقق مطلوب",
      completeCurrentSection: "يرجى إكمال القسم الحالي قبل الانتقال إلى القسم التالي.",
      fillRequiredFields: "يرجى ملء جميع الحقول المطلوبة في القسم الحالي قبل المتابعة.",
      ageDisplay: "العمر: {age} سنة",
      selected: "المحدد:",
      notImportant: "غير مهم",
      moderatelyImportant: "متوسط الأهمية",
      low: "منخفض",
      moderate: "متوسط",
      veryHigh: "عالي جداً",
      fieldHeight: "الطول",
      fieldWeight: "الوزن",
      fieldIdealWeight: "الوزن المثالي",
      mustBePositive: "{field} يجب أن يكون رقماً موجباً",
      validEmail: "يرجى إدخال عنوان بريد إلكتروني صحيح",
      mustBe15: "يجب أن يكون عمرك 15 سنة على الأقل للتقديم",
      ok: "موافق"
    },
    
    // Footer
    footer: {
      companyName: "Podium Racing الشرق الأوسط",
      tagline: "وجهتك المفضله لتطوير اداءك الرياضي",
      quickLinks: "الصفحات",
      home: "الرئيسية",
      coaches: "المدربين",
      athletes: "الرياضيين",
      aboutUs: "من نحن",
      copyright: "© 2025 Podium Racing الشرق الأوسط. جميع الحقوق محفوظة.",
      developedBy: "Developed and sponsor by PMI"
    }
  }
};

export const getTranslation = (key, language = 'en') => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key; // Return key if translation not found
    }
  }
  
  return value || key;
};
